import { formatBookingDate, formatBookingDateWithYear, formatBookingTimeRange } from './dateFormatters';

export default function formatBooking(slot, showYear = false) {
  const date = new Date(slot.UtcDate);
  // there are 60000 milliseconds in a minute

  const endDate = new Date(date.getTime() + slot.Duration * 60000);
  let slotDate = formatBookingDate(date, slot.SpecTimezoneIANAId);
  if (showYear) {
    slotDate = formatBookingDateWithYear(date, slot.SpecTimezoneIANAId);
  }

  const slotTimeRange = formatBookingTimeRange(date, endDate, slot.SpecTimezoneIANAId);

  return `${slotDate} <br /> ${slotTimeRange} (${slot.SpecTimezoneCode})`;
}
